// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__4NBa9","logoWrapper":"AppFooter_logoWrapper__Us7ay"};